import { type LucideIcon } from 'lucide-react'
import { Button } from './button'

interface Props {
  icon: LucideIcon
  headline: string
  subtext: string
  ctaLabel?: string
  onCta?: () => void
  ctaHref?: string
  className?: string
}

export function EmptyState({ icon: Icon, headline, subtext, ctaLabel, onCta, ctaHref, className = '' }: Props) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`}>
      <div className="rounded-full bg-muted p-4 mb-4">
        <Icon className="w-8 h-8 text-muted-foreground" aria-hidden="true" />
      </div>
      <h3 className="text-base font-semibold text-foreground mb-1">{headline}</h3>
      <p className="text-sm text-muted-foreground max-w-sm mb-6">{subtext}</p>
      {ctaLabel && (
        ctaHref ? (
          <a href={ctaHref}>
            <Button size="sm">{ctaLabel}</Button>
          </a>
        ) : (
          <Button size="sm" onClick={onCta}>{ctaLabel}</Button>
        )
      )}
    </div>
  )
}
